import LessonPlanForm from "../shared/LessonPlanForm";

const MaarifDailyLessonPlanForm = ({ planId }: { planId?: number }) => {
  return <LessonPlanForm type="maarif" planId={planId} />;
};

export default MaarifDailyLessonPlanForm;
